import styled from "styled-components"
import { Button_s, Colors } from "styles/app-styles"

export const Dropzone_s = styled.div`
  background: ${Colors.white};
  border: 2px dashed ${Colors.towerGrey};
  display: flex;
  flex-direction: column;
  font-color: ${Colors.blackPearl};
  font-family: 'Roboto', sans-serif;
  font-size: 18px;
  height: calc(100vh - 126px);
  position: fixed;
  width: calc(100% - 90px);
  z-index: 3;

  > div:first-child {
    border-bottom: 2px solid ${Colors.towerGrey};
    display: flex;
    flex-direction: row;
    height: 40px;
    justify-content: space-between;
    margin: 20px;

    span {
      padding-bottom: 20px;
    }

    svg {
      height: 18px;
      width: auto;
    }
  }

  > div:nth-child(2){
    align-items: center;
    display: flex;
    flex-direction: column;
    height: calc(100% - 40px);
    justify-content: center;

    ${Button_s}{
      margin-top: 20px;
    }

    p {
      font-weight: 300;
      margin-top: 20px;
      text-align: center;
    }
  
    svg {
      height: 20%;
      width: auto;
      .r-svg { fill: ${Colors.towerGrey}; }
    }
  }
`